import React, { useState } from "react";
import Navigation from "./Navigation";
import { SignOutButton } from "../SignOutButton";
import Drawer from "../Drawer";
import { useUser } from "../../services/useUser";

type Props = {};

const RightSection = (props: Props) => {
  const isAuthenticated = useUser().id ? true : false;
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <div className="flex items-center gap-4">
      {isAuthenticated && <SignOutButton />}
      <div className="">
        <button className="shadow px-3 py-2 rounded-md" onClick={toggleDrawer}>
          ☰
        </button>
        <Drawer
          isOpen={isDrawerOpen}
          onClose={toggleDrawer}
          position="right"
          title="Process Control Menu"
          width={380}
        >
          <Navigation />
        </Drawer>
      </div>
    </div>
  );
};

export default RightSection;
